/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "caption_colors_primary": "text-al-gray-800 group-data-[status=error]:text-al-error-500",
  "caption_size_default": "text-al-body-sm",
  "caption_size_alternative": "text-al-body-sm",
  "caption_variant_default": "transition-colors",
  "caption_variant_alternative": "transition-colors",
  "group_colors_primary": "",
  "group_size_default": "w-full",
  "group_variant_default": "relative flex flex-col items-start gap-y-1",
  "icon_colors_primary": "text-black group-data-[status=error]:text-al-error",
  "icon_size_default": "w-5 h-5",
  "icon_size_alternative": "w-5 h-5",
  "icon_variant_default": "transition-all absolute right-2 top-1/2 -translate-y-1/2 peer/icon",
  "icon_variant_alternative": "transition-all absolute right-2 top-1/2 -translate-y-1/2 peer/icon group-focus-within:translate-y-0 group-data-[filled]:translate-y-0 group-focus-within:top-6.5 group-data-[filled]:top-6.5",
  "input_colors_primary": "bg-white outline outline-0 ring-1 ring-inset hover:not-focus:bg-white hover:not-focus:outline-0 hover:not-focus:ring-1 hover:not-focus:ring-black group-data-[status=error]:outline group-data-[status=error]:outline-4 group-data-[status=error]:outline-error-200 group-data-[status=error]:ring-2 group-data-[status=error]:ring-inset outline-offset-0 outline-al-petroleum-100 ring-al-gray-600 focus:ring-1 focus:outline-2 focus:bg-white focus:ring-al-petroleum-600 placeholder:text-al-gray-600 hover:placeholder:text-black focus:placeholder:text-black group-data-[status=error]:bg-white group-data-[status=error]:hover:outline-al-error-100 group-data-[status=error]:focus:outline-al-error-100 group-data-[status=error]:hover:ring-2 group-data-[status=error]:ring-al-error-500 group-data-[status=error]:hover:ring-al-error-500 group-data-[status=error]:placeholder:text-black",
  "input_size_default": "p-2 w-full h-10 peer-[.absolute]/icon:pr-7 text-al-body-md",
  "input_size_alternative": "p-2 pt-6 w-full h-14 text-al-body-md",
  "input_variant_default": "transition-all rounded",
  "input_variant_alternative": "transition-all rounded placeholder:opacity-0",
  "label_colors_primary": "text-al-gray-900 group-data-[status=error]:text-al-error-500",
  "label_size_default": "text-al-body-sm",
  "label_size_alternative": "text-al-body-md group-focus-within:text-al-body-sm group-data-[filled]:text-al-body-sm",
  "label_variant_default": "transition-color relative",
  "label_variant_alternative": "transition-all absolute z-1 left-2 top-1/2 -translate-y-1/2 group-focus-within:top-1 group-data-[filled]:top-1 group-focus-within:translate-y-1 group-data-[filled]:translate-y-1",
  "size_default": "w-full",
  "size_alternative": "w-full",
  "colors_primary": "",
  "status_error": "",
  "variant_default": "flex flex-col items-start gap-y-1 group",
  "variant_alternative": "flex flex-col items-start gap-y-1 group"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "TextField");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;